// Work-items (Tasks) load FSM — D-VA-1 / R-18 (council-uiux-2026-10-02: "Tasks says
// 'No open work items' on failure"; contract law 9: error REFUSES, never a silent empty).
//
// Pure transition table + reducer, consumed by `WorkItemsPanel` through `useReducer`
// (the fetch result is component-owned data; the PHASE is this machine — the renderer
// never decides "empty" from a swallowed failure). Exported TRANSITIONS so
// setpoint-evals/ui-va-desktop-doors can fail on count drift (R-A1).
//
//   idle    ──FETCH──▶ loading
//   loading ──OK────▶ loaded       (zero rows here IS the designed empty state)
//   loading ──FAIL──▶ error        (refusal + Retry; the list is NOT shown)
//   loaded  ──FETCH─▶ loading      (refresh)
//   error   ──FETCH─▶ loading      (retry)
export type WorkItemsLoadPhase = 'idle' | 'loading' | 'loaded' | 'error';
export type WorkItemsLoadTrigger = 'FETCH' | 'OK' | 'FAIL';

export interface WorkItemsLoadState {
  phase: WorkItemsLoadPhase;
  /** Human-readable reason of the last failure; null unless phase === 'error'. */
  error: string | null;
}

export const TRANSITIONS: ReadonlyArray<{
  from: WorkItemsLoadPhase;
  trigger: WorkItemsLoadTrigger;
  to: WorkItemsLoadPhase;
}> = [
  { from: 'idle', trigger: 'FETCH', to: 'loading' },
  { from: 'loading', trigger: 'OK', to: 'loaded' },
  { from: 'loading', trigger: 'FAIL', to: 'error' },
  { from: 'loaded', trigger: 'FETCH', to: 'loading' },
  { from: 'error', trigger: 'FETCH', to: 'loading' },
];

export const WORK_ITEMS_LOAD_INITIAL: WorkItemsLoadState = { phase: 'idle', error: null };

export type WorkItemsLoadAction =
  | { type: 'FETCH' }
  | { type: 'OK' }
  | { type: 'FAIL'; error: string };

/** Pure reducer: an illegal (phase, trigger) pair leaves the state untouched. */
export function workItemsLoadReducer(
  state: WorkItemsLoadState,
  action: WorkItemsLoadAction,
): WorkItemsLoadState {
  const row = TRANSITIONS.find((t) => t.from === state.phase && t.trigger === action.type);
  if (!row) return state;
  return { phase: row.to, error: row.to === 'error' && action.type === 'FAIL' ? action.error : null };
}
